import React from "react";

export default function AboutUs() {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <div className="max-w-6xl mx-auto px-4 py-6 flex-grow">
        {/* Breadcrumb */}
        <div className="text-sm text-gray-500 mb-10">
          Home <span className="mx-2">/</span>
          Our Policies <span className="mx-2">/</span>
          <span className="text-black">About Us</span>
        </div>

        <div className="mb-6">
          <h1 className="text-2xl font-semibold text-left">About Us</h1>
          <div className="w-full h-[1px] bg-gray-300 mt-2"></div>
        </div>

        <div className="space-y-8 text-sm leading-7 text-gray-800">

          <section>
            <h2 className="text-amber-600 text-lg font-semibold mb-2">
              Who We Are
            </h2>
            <p>
              Discover everything that’s happening around you—effortlessly and in real time! Happenhood is designed as a unified cultural hub that brings together events, performances, and experiences from across your city into one easy-to-access platform.
              </p>
              <p className="mt-3">
                From music shows, theatre performances, workshops, and art exhibitions to plays, concerts, and any local happenings, the app ensures that you always stay informed about what’s going on in your neighbourhood. Whether you’re a resident looking to explore your city more deeply or a visitor wanting to experience its cultural pulse, this platform acts as your personal guide to everything vibrant and engaging around you.
                </p>
                <p className="mt-3">
                What makes Happenhood truly unique is its community-driven approach. Anyone can contribute—if you come across an event poster on the street, social media, or anywhere else, you can simply click a picture and share it on the app. This creates a constantly updated, crowdsourced feed of events that might otherwise go unnoticed.
                </p>
                <p className="mt-3">
                The platform also empowers users to become creators, not just participants. You can host your own events—whether they are free or ticketed—and reach a wider audience effortlessly. For those looking to go beyond physical boundaries, the app also supports hosting and streaming digital events, enabling you to connect with audiences anywhere.
                </p>
                <p className="mt-3">
                When it comes to attending events, the app simplifies the entire process. You can book tickets directly within the platform or be seamlessly redirected to trusted ticketing partners, ensuring a smooth and convenient experience.
                </p>
                <p className="mt-3">
                At its core, the application is built on a simple yet powerful idea: you should never miss out on anything happening around you. By combining discovery, community participation, event hosting, and ticketing into one place, it transforms how people engage with culture, creativity, and experiences in their city.
                </p>
          </section>

          <section>
            <h2 className="text-amber-600 text-lg font-semibold mb-2">
              Our Mission
            </h2>
            <p>
              Our mission is to simplify how people discover, book, and manage events by offering a seamless, secure, and user-friendly platform.
            </p>
          </section>

          <section>
            <h2 className="text-amber-600 text-lg font-semibold mb-2">
              What We Offer
            </h2>
            <p>
              We provide a complete solution for both users and event organizers, including easy event discovery, smooth ticket booking, and powerful tools to manage events efficiently.
            </p>
          </section>

          <section>
            <h2 className="text-amber-600 text-lg font-semibold mb-2">
              Why Choose Us
            </h2>
            <p>
              With features like social login, real-time booking, and an intuitive interface, Happenhood ensures a hassle-free experience for users while empowering organizers to reach a wider audience.
            </p>
          </section>

          <section>
            <h2 className="text-amber-600 text-lg font-semibold mb-2">
              Our Vision
            </h2>
            <p>
              We aim to become a leading platform that connects communities through events and shared experiences, making every moment count.
            </p>
          </section>

          <section>
            <h2 className="text-amber-600 text-lg font-semibold mb-2">
              Contact Us
            </h2>
            <p>
              Have questions or need support? Reach out to us at:
            </p>
            <p className="text-blue-500">support@happenhood.com</p>
            <p>📍 Happenhood, Noida, India</p>
          </section>

        </div>
      </div>
    </div>
  );
}
